export enum SuggestedInsuranceCalculationKind {
    Income = 1,
    Mortgage = 2,
}
